import * as React from "react";
import { cn } from "@/lib/utils";

/**
 * Native <select> wrapped with shadcn-style Tailwind utilities.
 * Full keyboard & accessibility support comes from the browser's native widget.
 * Used by AiCostsPage filter dropdowns.
 */
const Select = React.forwardRef<
  HTMLSelectElement,
  React.SelectHTMLAttributes<HTMLSelectElement>
>(({ className, children, ...props }, ref) => (
  <select
    ref={ref}
    className={cn(
      "flex h-9 w-full rounded-sm border border-control-border bg-control px-3 text-sm",
      "transition-colors pointer-coarse:h-11",
      "focus-visible:outline-none focus-visible:border-ring focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
      "disabled:cursor-not-allowed disabled:opacity-50",
      className,
    )}
    {...props}
  >
    {children}
  </select>
));
Select.displayName = "Select";

export { Select };
